import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { METHODS, SERVICES } from '../../api/constants';
import { makeRequest } from '../../api/api';
import CryptoJS from 'crypto-js';

export const fetchTickets = createAsyncThunk(
  'tickets/fetchTickets',
  async (param) => {
    try {
      const hash = CryptoJS.HmacSHA256(
        JSON.stringify(param),
        '2d1e1v2e4s3h8zkkhehkod2d02fhjewjbd2whj4'
      ).toString(CryptoJS.enc.Hex);

      const response = await makeRequest(
        SERVICES.SPRINGBOOT_TO_NODE_APIS,
        '/ticket/fetch',
        METHODS.GET,
        { ...param },
        {},
        [
          { key: 'access-key', value: 'sxb0zhsqm8yjpttc79iqlizxyd3e1a2' },
          { key: 'signature', value: hash }
        ]
      );
      return response?.data;
    } catch (e) {
      thunkApi.rejectWithValue(e);
    }
  }
);

export const ticketSlice = createSlice({
  name: 'ticketSlice',
  initialState: {
    isTicketLoading: false,
    ticketsData: [],
    error: false
  },
  //   reducers: {
  //     resetSkillTestLoadingState: (state) => {
  //       return {
  //         loading: true
  //       };
  //     }
  //   },
  extraReducers: (builder) => {
    builder.addCase(fetchTickets.pending, (state) => {
      state.isTicketLoading = true;
    });
    builder.addCase(fetchTickets.fulfilled, (state, action) => {
      state.isTicketLoading = false;
      state.ticketsData = 
      [
        {
          source: 9,
          status: 2,
          subject: 'Testing Herovired Tech Team1',
          id: 49145,
          created_at: '2025-02-14T08:07:20Z'
        },
        {
          source: 9,
          status: 3,
          subject: 'Testing Herovired Tech Team2',
          id: 49145,
          created_at: '2025-02-14T08:07:20Z'
        },
        {
          source: 9,
          status: 4,
          subject: 'Testing Herovired Tech Team3',
          id: 49145,
          created_at: '2025-02-14T08:07:20Z'
        },
        {
          source: 9,
          status: 5,
          subject: 'Testing Herovired Tech Team4',
          id: 49145,
          created_at: '2025-02-14T08:07:20Z'
        },
        {
          source: 9,
          status: 6,
          subject: 'Testing Herovired Tech Team5',
          id: 49145,
          created_at: '2025-02-14T08:07:20Z'
        },
        {
          source: 9,
          status: 7,
          subject: 'Testing Herovired Tech Team6',
          id: 49145,
          created_at: '2025-02-14T08:07:20Z'
        },
        {
          source: 9,
          status: 8,
          subject: 'Testing Herovired Tech Team7',
          id: 49145,
          created_at: '2025-02-14T08:07:20Z'
        },
        {
          source: 9,
          status: 5,
          subject: 'Testing Herovired Tech Team8',
          id: 49145,
          created_at: '2025-02-14T08:07:20Z'
        },
        {
          source: 9,
          status: 8,
          subject: 'Testing Herovired Tech Team9',
          id: 49145,
          created_at: '2025-02-14T08:07:20Z'
        },
        {
          source: 9,
          status: 5,
          subject: 'Testing Herovired Tech Team10',
          id: 49145,
          created_at: '2025-02-14T08:07:20Z'
        }
      ];
      //   action.payload?.data || [];
    });
    builder.addCase(fetchTickets.rejected, (state) => {
      state.isTicketLoading = false;
      state.ticketsData = [];
    });
  }
});

// export const { resetSkillTestLoadingState } = ticketSlice.actions;
export default ticketSlice.reducer;
